import * as lodash from './lodash';
export { alignBox } from '@byted/light-render/lib/utils/bbox';
export function clampRange(range, clamp) {
    var start = range[0], end = range[1];
    var gap = Math.abs(start - end);
    var min = clamp[0], max = clamp[1];
    if (Math.max(start, end) > max) {
        end = max;
        start = max - gap;
    }
    if (Math.min(start, end) < min) {
        start = min;
        end = start + gap;
    }
    return [start, end];
}
export function clipLineInBox(lineAttr, minX, maxX, minY, maxY) {
    lineAttr.x1 = lodash.clamp(lineAttr.x1, minX, maxX);
    lineAttr.x2 = lodash.clamp(lineAttr.x2, minX, maxX);
    lineAttr.y1 = lodash.clamp(lineAttr.y1, minY, maxY);
    lineAttr.y2 = lodash.clamp(lineAttr.y2, minY, maxY);
}
export function clipRectInBox(rectAttr, minX, maxX, minY, maxY) {
    var x1 = Math.min(rectAttr.x, rectAttr.x + rectAttr.width);
    var x2 = Math.max(rectAttr.x, rectAttr.x + rectAttr.width);
    var y1 = Math.min(rectAttr.y, rectAttr.y + rectAttr.height);
    var y2 = Math.max(rectAttr.y, rectAttr.y + rectAttr.height);
    x1 = lodash.clamp(minX, maxX);
    x2 = lodash.clamp(minX, maxX);
    y1 = lodash.clamp(minY, maxY);
    y2 = lodash.clamp(minY, maxY);
    rectAttr.x = x1;
    rectAttr.y = y1;
    rectAttr.width = y2 - y1;
    rectAttr.height = x2 - x1;
}
